// extracted by mini-css-extract-plugin
module.exports = {"listItem":"TableListItem_listItem__2zMPI","labelItem":"TableListItem_labelItem__2T029","checkbox":"TableListItem_checkbox__1RS3a"};